/* eslint-disable react-hooks/exhaustive-deps */
import "../App.css";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import "../css/Rekap.css";
import { useEffect, useState } from "react";
import { utils, writeFile } from "xlsx";
import { requestWithHeaders } from "../api/requestMethods";
import DatePicker from "react-date-picker";
import { endOfToday, format } from "date-fns";
import { BeatLoader } from "react-spinners";

import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";

function Rekap() {
  const [modal, setModal] = useState(false);
  const [rekap, setRekap] = useState([]);
  const [paginationData, setPaginationData] = useState(null);
  const [modalData, setModalData] = useState({});
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const limit = 10;
  const [startPeriod, setStartPeriod] = useState(null);
  const [endPeriod, setEndPeriod] = useState(null);
  const [locket, setLocket] = useState("");

  const service_types = [
    { service_type: 1, name: "Mahasiswa" },
    { service_type: 2, name: "Calon Mahasiswa" },
    { service_type: 3, name: "Dosen" },
    { service_type: 4, name: "Tenaga Pendidik" },
    { service_type: 5, name: "Masyarakat" },
    { service_type: 6, name: "Alumni" },
  ];

  const queue_status = [
    { status: 1, name: "Menunggu" },
    { status: 2, name: "Dipanggil" },
    { status: 3, name: "Sedang dilayani" },
    { status: 4, name: "Selesai" },
    { status: 10, name: "Dilewati" },
    { status: 11, name: "Tidak bisa dilayani" },
  ];

  const exportToExcel = async (fileName) => {
    const res = await requestWithHeaders.get(
      `/api/admin/locket-recap?startPeriod=${format(
        startPeriod,
        "yyyy-MM-dd"
      )}&endPeriod=${format(endPeriod, "yyyy-MM-dd")}&locket=${locket}`
    );
    const jsonData = res?.data?.data;
    const convertedRekap = [];
    jsonData.map((data, i) => {
      let convObj = { ...data };
      delete convObj.user;
      delete convObj.user_id;
      convObj.service_type = service_types[data.service_type - 1]?.name;
      convObj.status_label = queue_status.find(
        (item) => item.status === data.status
      )?.name;
      const combined = { ...convObj, ...data?.user };
      return convertedRekap.push(combined);
    });

    // Create a new workbook
    const workbook = utils.book_new();

    // Convert JSON data to a worksheet
    const worksheet = utils.json_to_sheet(convertedRekap);

    // Append the worksheet to the workbook
    utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate Excel file and trigger download
    writeFile(workbook, `${fileName}.xlsx`);
  };

  const toggleModal = (data) => {
    setModal(!modal);
    setModalData(data);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await requestWithHeaders.get(
        `/api/admin/locket-recap?startPeriod=${format(
          startPeriod,
          "yyyy-MM-dd"
        )}&endPeriod=${format(
          endPeriod,
          "yyyy-MM-dd"
        )}&page=${page}&limit=${limit}&locket=${locket}`
      );
      setRekap(res?.data?.data);
      setPaginationData(res?.data?.pagination);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
    setLoading(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (startPeriod !== "" && endPeriod !== "") {
      fetchData();
    }
  }, [page]);

  const submitPeriod = () => {
    fetchData();
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    // Array of months in Bahasa Indonesia
    const months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    // Get day, month and year
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    // Return formatted date
    return `${day}-${month}-${year}`;
  };

  const formatRating = (filledStars) => {
    let stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= filledStars) {
        stars.push(
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#EFC02E"
            className="bi bi-star-fill mr-1"
            viewBox="0 0 16 16"
          >
            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
          </svg>
        );
      } else {
        stars.push(
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#EFC02E"
            className="bi bi-star mr-1"
            viewBox="0 0 16 16"
          >
            <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
          </svg>
        );
      }
    }
    return stars;
  };

  const pageButtons = [];
  for (let index = 1; index <= paginationData?.totalPages; index++) {
    pageButtons.push(
      <li className="page-item">
        <button
          className={`page-link ${modal ? "modal-open-handler" : ""}`}
          onClick={() => setPage(index)}
        >
          {index === page ? <b>{index}</b> : index}
        </button>
      </li>
    );
  }

  return (
    <div>
      <Topbar />
      <div className="row">
        <div className="col-md-2">
          <Sidebar />
        </div>
        <div
          className="col-md-10"
          style={{ marginLeft: "250px", paddingTop: "56px" }}
        >
          <div className="row px-5 mt-5">
            <div className="card shadow h-100 py-2 pl-3">
              <div className="card-body pt-2 pr-3">
                <div
                  className=" mx-3 mt-3 mb-3 row"
                  style={{ fontSize: 24, fontWeight: 700 }}
                >
                  Rekapitulasi Data Pengunjung
                </div>
                <hr />
                <div className="row ml-2 d-flex align-items-center">
                  <span className="col-md-2">Periode Antrian</span>
                  <span className="col-md-2 Sample__container">
                    <main className="Sample__container__content">
                      <DatePicker
                        disabled={loading}
                        value={startPeriod}
                        className="datepicker"
                        locale="id"
                        onChange={setStartPeriod}
                        format="dd/MM/yyyy"
                        maxDate={endOfToday()}
                      />
                    </main>
                  </span>
                  -
                  <span className="col-md-2 Sample__container">
                    <main className="Sample__container__content">
                      <DatePicker
                        disabled={loading}
                        value={endPeriod}
                        locale="id"
                        className="datepicker"
                        onChange={setEndPeriod}
                        format="dd/MM/yyyy"
                        maxDate={endOfToday()}
                      />
                    </main>
                  </span>
                </div>
                <div className="row ml-2 my-3 d-flex align-items-center">
                  <span className="col-md-2">Locket</span>
                  <div className="d-flex col-md-3 mr-3">
                    <select
                      className="custom-dropdown"
                      value={locket}
                      onChange={(e) => setLocket(e.target.value)}
                      disabled={loading}
                    >
                      <option value="">Semua</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                    </select>
                  </div>
                </div>
                <div className="row my-3 mx-3 d-flex justify-content-between">
                  <button
                    className="btn btn-rekap"
                    onClick={() => submitPeriod()}
                    disabled={loading || !startPeriod || !endPeriod}
                  >
                    {!loading ? (
                      "Submit"
                    ) : (
                      <BeatLoader size={8} color="#fff" margin={2} />
                    )}
                  </button>
                  <button
                    className="btn btn-rekap"
                    onClick={() => exportToExcel("allRekap")}
                    disabled={loading || !rekap || rekap.length === 0}
                  >
                    Download
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="white"
                      className="bi bi-download ml-2 mb-1"
                      viewBox="0 0 16 16"
                    >
                      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                    </svg>
                  </button>
                </div>
                <hr className="mt-3" />
                <div className="row mx-3 mt-3">
                  <table className="table table-bordered align-middle">
                    <thead>
                      <tr>
                        <th scope="col">
                          <div
                            className="d-flex align-items-center justify-content-center thead"
                            style={{ height: "42px" }}
                          >
                            Nama
                          </div>
                        </th>
                        <th scope="col">
                          <div
                            className="d-flex align-items-center justify-content-center thead"
                            style={{ height: "42px" }}
                          >
                            Fakultas/SatKer
                          </div>
                        </th>
                        <th scope="col">
                          <div
                            className="d-flex align-items-center justify-content-center thead"
                            style={{ height: "42px" }}
                          >
                            Jenis Layanan
                          </div>
                        </th>
                        <th scope="col">
                          <div
                            className="d-flex align-items-center justify-content-center thead"
                            style={{ height: "42px", textAlign: "center" }}
                          >
                            Layanan yang Dibutuhkan
                          </div>
                        </th>
                        <th scope="col">
                          <div
                            className="d-flex align-items-center justify-content-center thead"
                            style={{ height: "42px" }}
                          >
                            Tanggal
                          </div>
                        </th>
                        <th scope="col">
                          <div
                            className="d-flex align-items-center justify-content-center thead"
                            style={{ height: "42px" }}
                          >
                            Rating
                          </div>
                        </th>
                        <th scope="col">
                          <div
                            className="d-flex align-items-center justify-content-center thead"
                            style={{ height: "42px" }}
                          >
                            Detail
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {rekap?.length === 0 && (
                        <>
                          <tr>
                            <td colSpan={7}>
                              <div className="img-bg">
                                <div>
                                  <img
                                    className="row ml-5"
                                    src="images/not-found.png"
                                    alt="Not Found"
                                  />
                                  <p className="mt-1 nf-text">
                                    Anda belum memasukkan periode antrian
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </>
                      )}

                      {rekap?.map((r, i) => (
                        <tr key={i}>
                          <td>
                            <div
                              className="d-flex align-items-center justify-content-center m-1"
                              style={{ textAlign: "center" }}
                            >
                              {r?.user?.fullname}
                            </div>
                          </td>
                          <td>
                            <div
                              className="d-flex align-items-center justify-content-center m-1 w-100 h-100"
                              style={{ textAlign: "center" }}
                            >
                              <div className="mb-1">{r?.user?.faculty}</div>
                            </div>
                          </td>
                          <td>
                            <div
                              className="d-flex align-items-center justify-content-center m-1 text-middle"
                              style={{ textAlign: "center" }}
                            >
                              {service_types[r?.service_type - 1].name}
                            </div>
                          </td>
                          <td>
                            <div
                              className="d-flex align-items-center justify-content-center m-1"
                              style={{ textAlign: "center" }}
                            >
                              {r?.service_name}
                            </div>
                          </td>
                          <td>
                            <div
                              className="d-flex align-items-center justify-content-center m-1"
                              style={{ textAlign: "center" }}
                            >
                              {formatDate(r?.datetime)}
                            </div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              {formatRating(r?.user_review_score)}
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center justify-content-center m-3">
                              <button
                                className="btn button-custom-text btn-outline-info"
                                onClick={() => toggleModal(r)}
                              >
                                <span
                                  style={{
                                    color: "#53B1FD",
                                    fontSize: 16,
                                    fontWeight: 700,
                                  }}
                                >
                                  Lihat
                                </span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="#53B1FD"
                                  className="bi bi-file-earmark-text ml-2 mb-1"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5" />
                                  <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                                </svg>
                              </button>
                              {modal && (
                                <div className="modal-custom">
                                  <div
                                    onClick={() => toggleModal(null)}
                                    className="overlay"
                                  ></div>
                                  <div className="modal-content p-5">
                                    <div className="row mt-2">
                                      <div className="col mt-1 mr-3">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Nama Pengunjung
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Nama"
                                            aria-label="Nama"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.user?.fullname
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col mt-1">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Fakultas/SatKer
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Fakultas"
                                            aria-label="Fakultas"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.user?.faculty
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col mr-3">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          NIM/NIP
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="NIM/NIP"
                                            aria-label="NIM/NIP"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.user?.nim_nip
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Status
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Status"
                                            aria-label="Status"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              queue_status.find(
                                                (item) =>
                                                  item.status ===
                                                  modalData.status
                                              )?.name
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col mr-3">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Nomor Telepon
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Nomor Telepon"
                                            aria-label="Nomor Telepon"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.user?.no_hp
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Email
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Email"
                                            aria-label="Email"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.user?.email
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Jenis Layanan
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Jenis Layanan"
                                            aria-label="Jenis Layanan"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              service_types[
                                                modalData?.service_type - 1
                                              ].name
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Layanan yang Dibutuhkan
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Layanan yang Dibutuhkan"
                                            aria-label="Layanan yang Dibutuhkan"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.service_name
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Pertanyaan/Keluhan Singkat
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <input
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Pertanyaan/Keluhan Singkat"
                                            aria-label="Pertanyaan/Keluhan Singkat"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={modalData?.complaint}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Catatan Akhir Pelayanan
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <textarea
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Catatan Akhir Pelayanan"
                                            aria-label="Catatan Akhir Pelayanan"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.completion_notes
                                            }
                                            rows={4}
                                            style={{ resize: "none" }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Umpan Akhir Pelayanan
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          <textarea
                                            type="text"
                                            className="form-control disabled-white"
                                            disabled
                                            placeholder="Umpan Balik Pelayanan"
                                            aria-label="Umpan Balik Pelayanan"
                                            aria-describedby="addon-wrapping"
                                            defaultValue={
                                              modalData?.user_review_description
                                            }
                                            rows={4}
                                            style={{ resize: "none" }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mt-3">
                                      <div className="col">
                                        <div
                                          className="mb-2"
                                          style={{ fontSize: 14 }}
                                        >
                                          Rating
                                        </div>
                                        <div className="input-group flex-nowrap">
                                          {formatRating(
                                            modalData?.user_review_score
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <button
                                      className="close-modal"
                                      onClick={toggleModal}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="black"
                                        className="bi bi-x-lg"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                      </svg>
                                    </button>
                                    {/* <div className="modal-footer" /> */}
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="row d-flex my-3 mx-3 justify-content-between align-items-center">
                  <div>
                    Menampilkan{" "}
                    {(paginationData?.page - 1) * paginationData?.limit +
                      rekap?.length || 0}{" "}
                    dari {paginationData?.totalItems || 0} antrian
                  </div>
                  <nav
                    aria-label="Page navigation example"
                    className="align-items-center"
                  >
                    <ul className="pagination">
                      <li className="page-item">
                        <button
                          className={`page-link ${
                            modal ? "modal-open-handler" : ""
                          }`}
                          aria-label="Previous"
                          disabled={paginationData?.page === 1 ? true : false}
                          onClick={() => setPage(page - 1)}
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>
                      {pageButtons}
                      {/* <li className="page-item">
                        <button
                          className={`page-link ${
                            modal ? "modal-open-handler" : ""
                          }`}
                          onClick={() => setPage(2)}
                        >
                          2
                        </button>
                      </li> */}
                      <li className="page-item">
                        <button
                          className={`page-link ${
                            modal ? "modal-open-handler" : ""
                          }`}
                          href="/#"
                          aria-label="Next"
                          disabled={
                            paginationData?.page >= paginationData?.totalPages
                          }
                          onClick={() => setPage(page + 1)}
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Rekap;
